import React from "react";
import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLocationDot, faTrash} from "@fortawesome/free-solid-svg-icons";
import {NewsItem, Session, User} from "../../types/Types";
import {addAnchorTags, getDateFromTimeStamp, getPhotoDate} from "../../util/Util";
import UserTag from "../../users/tag/UserTag";
import VerificationTag from "../../tag/VerificationTag";
import LikeButton from "../../tag/likes/LikeButton";
import {V2GlassChip, V2GlassSurface} from "./V2Glass";

interface Props {
    comment: NewsItem;
    user: User | undefined;
    session: Session | undefined;
    currentUser: User | undefined;
    locationName?: string;
    likesMap?: Map<string, boolean>;
    onLikeCountChange?: (commentId: string, adjustment: number) => void;
    canDelete?: boolean;
    onDelete?: (commentId: string) => void;
}

function V2CommentRow(props: Props) {
    const locationName = props.locationName || props.comment.locationName || "Pub";
    const isCheckedIn = !!props.session
        && props.session.locationId === props.comment.locationId
        && getDateFromTimeStamp(props.session.checkOutTime) > new Date();
    const showVerification = props.comment.verified || isCheckedIn;

    return (
        <V2GlassSurface className="v2-comment-row v2-glass-list-row">
            <div className="v2-comment-bubble">
                <span dangerouslySetInnerHTML={{__html: addAnchorTags(props.comment.payload)}} />
            </div>
            <div className="v2-comment-meta">
                <div className="v2-comment-author-location">
                    <UserTag
                        user={props.user}
                        visit={undefined}
                        session={props.session}
                        padRight={false}
                        hideLocationDot={true}
                        linksToTab="comments"
                        chipClassName="v2-glass-user-chip"
                    />
                    <div className="v2-comment-location">
                        <Link to={`/location/${props.comment.locationId}/comments`} className="v2-comment-location-link">
                            <V2GlassChip className="v2-glass-location-chip">
                                <FontAwesomeIcon icon={faLocationDot} />
                                <span>{locationName}</span>
                            </V2GlassChip>
                        </Link>
                        {showVerification && <VerificationTag active={isCheckedIn} chipClassName="v2-glass-verification-chip" />}
                    </div>
                </div>
                <div className="v2-comment-actions">
                    {props.currentUser && props.likesMap && (
                        <LikeButton
                            entityId={props.comment.id}
                            likeType="COMMENT"
                            initialLikeCount={props.comment.likeCount || 0}
                            isLiked={props.likesMap.get(props.comment.id) || false}
                            currentUser={props.currentUser}
                            locationId={props.comment.locationId}
                            locationName={locationName}
                            onLikeCountChange={props.onLikeCountChange}
                            buttonClassName="v2-comment-like-button"
                        />
                    )}
                    {props.canDelete && props.onDelete && (
                        <button
                            className="v2-comment-delete-button"
                            type="button"
                            aria-label="Delete comment"
                            onClick={() => props.onDelete!(props.comment.id)}
                        >
                            <FontAwesomeIcon icon={faTrash} />
                        </button>
                    )}
                    <V2GlassChip className="v2-comment-date-chip">
                        {getPhotoDate(props.comment.lastModified)}
                    </V2GlassChip>
                </div>
            </div>
        </V2GlassSurface>
    );
}

export default V2CommentRow;
